export default __webpack_public_path__ + "static/NewRocker-Regular-786e6c54c1267ded1c5c6375e5f291f4.woff";